import axios from "axios";
import { getCalcFormula } from "./namespace";
import { response } from "../../lib/utils";

export async function calculateFormula(prompt: string, intent: string, conversationMem: string) {
    try {
        const res = await axios.post(getCalcFormula, {
            prompt: prompt,
            intent: intent,
            conversation: conversationMem
        });
        if (!res.data) {
            return response(false, "No data found", null);
        }
        return response(true, "Data found", res.data[0].output);
    } catch (error: any) {
        throw new Error(error);
    }
}